<!--
 * @Author: your name
 * @Date: 2020-08-17 11:34:05
 * @LastEditTime: 2022-12-07 13:57:58
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/submit-order/component/Spicy/index.vue
-->
<style scoped lang="sass">
.spicy
  font-size: 0

  .top_box
    display: inline-block

  .lower
    display: flex
    align-items: center

  .top_margin
    margin-top: 10px

  .top
    display: flex
    align-items: center
    height: 20px
    line-height: 20px
    padding: 0 6px
    background: #DE0D16
    color: #fff
    border-radius: 10px
    font-size: 12px
    font-weight: 500

    .spice_level
      margin-right: 6px
      line-height: 1px

    .icon
      display: flex
      align-items: center
      justify-content: center
      width: 9px
      height: 13px
      margin-right: 2px

      &:last-child
        margin-right: 0

      .grey
        opacity: .5

  .img
    width: 100%
    height: 100%

.spot
  padding: 0 5px

.each_circle
  display: flex
  justify-content: center
  align-items: center
  margin-right: 7px

  &:last-child
    margin-right: 0

  .each_circle_img
    height: 20px
    width: 20px
    margin-right: 3px

.content
  font-size: 12px

.each_circle_span
  white-space: nowrap
  color: var(--menu-primary-text-colour)

.title
  margin: 12px 0 10px 0
  line-height: 12px

  .contain_tags
    margin-right: 2px

</style>

<template lang="pug">
.spicy
  .top_box(v-if="number")
    .top(:style="{ 'background': background }")
      .spice_level {{ spiceLevel | fix }}
      span.icon(
        v-if="number"
        v-for="(item, index) in n"
        :key="item.id"
      )
        img.img(
          v-if="number"
          :class="index < number ? '' : 'grey'"
          :src="pepperImg"
        )
  .title.b.content(v-if="containTags && containTags.length") {{ containsLabel }}&nbsp;
    span.contain_tags(v-for="item,index in containTags") {{ containTagText(item) }}{{ index + 1 < containTags.length ? ',' : '' }}
  .lower(v-if="tags && tags.length" :class='{top_margin: !(containTags && containTags.length)}')
    span.each_circle(
      v-if="imgScr(item) !== 'other'"
      v-for="(item, index) in tags"
      :key="item.id"
    )
      img.each_circle_img(:src="imgScr(item)")
      span.content.each_circle_span {{ item }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { t } from '@/utils/language'
import { decorateContainsTag } from '@/utils/seafoodOrigin'

@Component({
  props: {
    n: {
      type: Number,
      default: 3
    },
    spiceLevel: {
      type: String
    },
    tags: {
      type: Array
    },
    containTags: { // Ingredient label   // 配料标签列表
      type: Array,
    },
    // Seafood country-of-origin (backend sends it only for AU venues with a
    // Seafood product + value set). null/absent = old behavior.
    // 海鲜产地（仅澳洲 venue + 含 Seafood + 已设值时后端下发）。空/缺 = 老逻辑。
    seafoodOrigin: {
      type: String,
      default: null
    }
  },

  filters: {
    fix(val) { // Capitalization, compatible with dirty data   // 首字母大写，兼容脏数据
      let name = val
      if (val === 'mid') name = 'Mild'
      return name.charAt(0).toUpperCase() + name.slice(1)
    }
  },
  computed: {
    // "Contains:" label translation / "含有:" 标签翻译
    containsLabel() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('contains_label', 'Contains:')
    },

    /**
     * @returns {Number} Corresponding Spiciness Quantity
     */
    /**
     * @returns {Number} 对应的辣度数量
     */
    number() {
      if (this.spiceLevel === 'hot') {
        this.background = '#DE0D16'
        return 3
      } else if (this.spiceLevel === 'medium') {
        this.background = '#F77E21'
        return 2
      } else if (this.spiceLevel === 'mid' || this.spiceLevel === 'mild') {
        this.background = '#7EB515'
        return 1
      } else {
        return 0
      }
    },
  }
})
class Spicy extends Vue {
  pepperImg = require('@/assets/spice/pepper.png')
  background = '' // Background color corresponding to pungency   // 辣度对应的背景色

  /**
   * Display text for one contains-tag. The Seafood tag gets its
   * country-of-origin appended ("Seafood • {origin}") when the backend
   * provided one; every other tag is shown unchanged.
   * 单个 contains 标签的展示文字：海鲜标签在有产地时追加 "Seafood • {产地}"，
   * 其它标签原样显示。
   *
   * @param {String} item - one containTags entry
   * @returns {String}
   */
  containTagText(item) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return decorateContainsTag(item, this.seafoodOrigin)
  }

  /**
   * @param item {String} Corresponding picture name
   * @returns {String} Corresponding picture address
   */
  /**
   * @param item {String} 对应图片名称
   * @returns {String} 对应的图片地址
   */
  imgScr(item) {
    if (item === 'Gluten free') {
      return require('@/assets/spice/GlutenFree.png')
    } else if (item === 'Dairy free') {
      return require('@/assets/spice/DairyFree.png')
    } else if (item === 'Vegetarian') {
      return require('@/assets/spice/Vegetarian.png')
    } else if (item === 'Vegan') {
      return require('@/assets/spice/Vegan.png')
    } else {
      // The returned other is compatible with the tags that are not in the existing design drawing. The returned other is always hidden and not displayed
      // 返回 other 是兼容现有设计图中没有的 tags 类型的情况。返回 other 一律隐藏不显示
      return 'other'
    }
  }
}

export default Spicy
</script>
